import React from 'react'
import classNames from 'classnames'

import './Text.scss'
import { ThemeColours, ThemeFontSize } from '../../../types/theme'

export interface Props {
  children?: React.ReactNode
  className?: string
  colour?: ThemeColours
  size?: ThemeFontSize
  center?: boolean
  bold?: boolean
  'data-test'?: string
  mono?: boolean
  medium?: boolean
  vertical?: boolean
  italic?: boolean
  right?: boolean
  allowOverflow?: boolean
  respectNewLine?: boolean
  isHtml?: boolean
  dangerouslySetInnerHTML?: {
    __html: string
  }
}

function Text ({ children, colour, size, bold, center, className, mono, medium, vertical, italic, right, allowOverflow, respectNewLine, isHtml = false, ...rest }: Props) {
  const colourClass = colour ? `colour-${colour}` : null
  const sizeClass = size ? `size-${size}` : null

  if (isHtml) {
    return (
      <div
        dangerouslySetInnerHTML={{ __html: String(children) }}
        className={classNames('text', {
          center,
          bold,
          mono,
          medium,
          vertical,
          italic,
          right,
          allowOverflow
        }, colourClass, sizeClass, className)}
        {...rest}
      />
    )
  }
  return (
    <div className={classNames('text', {
      center,
      bold,
      mono,
      medium,
      vertical,
      italic,
      right,
      allowOverflow,
      respectNewLine
    }, colourClass, sizeClass, className)} {...rest}>
      {children}
    </div>
  )
}

export default Text
